import React from 'react';
import KesehatanIcon from '../CategoryImages/feature_2.png'
import '../CategoryBanner/categorybanner.css'

const BannerKesehatan = () => {
    return (
        <div className="banner-category">
            <div className="banner-category-row">
                <img src={KesehatanIcon} alt="" width="100" />
                <div className="banner-category-column">
                    <h5 className="banner-name">Kesehatan</h5>
                    <p className="banner-name-txt">Donasi Terbuka</p>
                </div>
            </div>
        </div>
    )
}

export default BannerKesehatan;